import './SnippetContainer.scss';
import { VscCopy } from 'react-icons/vsc';
import CopyToClipboard from 'react-copy-to-clipboard';

interface Props {
    title?: string;
    description?: string;
    code: string;
    copyEnabled?: boolean;
}

const SnippetContainer = ({ title, code, copyEnabled = true }: Props) => {
    const copyButton = (
        <>
            <CopyToClipboard text={code}>
                <VscCopy className="snippet-copy-button"></VscCopy>
            </CopyToClipboard>
        </>
    )

    return (
        <div className="snippet-container">
            <div className="snippet-header">
                {title && <div className="snippet-title">{title}</div>}
                {copyEnabled && copyButton}
            </div>
            <pre className="snippet-code">
                <code>
                    {code}
                </code>
            </pre>
        </div>
    )
}

export default SnippetContainer;